import Glide, { Controls, Keyboard, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
import refs from '../helpers/refs'

class CFeatureSlider {
  constructor (el) {
    this.slider = el
    this.$refs = refs(el)

    this.init()
  }

  init () {
    this.glide = new Glide(this.$refs.slider, {
      autoheight: true,
      gap: -48,
      type: 'slider',
      focusAt: 'center',
      perView: 1.62,
      bound: true,
      breakpoints: {
        768: {
          perView: 1.24,
          gap: 4
        },
        1024: {
          perView: 1.62,
          gap: -48
        }
      }
    }).mount({ Controls, Keyboard, Breakpoints, Swipe })

    this.slider
      .querySelector('.glide__slide--active')
      .classList.add('opacity-100', 'md:scale-100', 'scale-100')

    // Remove active styles on slide switch
    this.glide.on('run', () => {
      this.slider
        .querySelector('.glide__slide--active')
        .classList.remove('opacity-100', 'md:scale-100', 'scale-100')
      const video = this.slider.querySelector('.glide__slide--active video')

      // Some slides may have an image instead of a video
      if (video) {
        video.pause()
      }

      this.setControls(this.glide.index)
    })

    // Add active styles post animation
    this.glide.on('run.after', () => {
      this.slider
        .querySelector('.glide__slide--active')
        .classList.add('opacity-100', 'md:scale-100', 'scale-100')
      const video = this.slider.querySelector('.glide__slide--active video')

      // Some slides may have an image instead of a video
      if (video) {
        video.play()
      }
    })

    // Controls below slidersk
    this.$refs.controls?.forEach((control) => {
      control.addEventListener('click', (e) => {
        e.preventDefault()
        const index = parseInt(control.getAttribute('data-index'))
        this.glide.go(`=${index}`)
        this.setControls(index)
      })
    })

    // Navigate by clicking on next/prev slide
    this.slider.querySelectorAll('.glide__slide').forEach((slide) => {
      slide.addEventListener('click', (e) => {
        const index = parseInt(
          e.target.closest('.glide__slide').attributes['data-index'].value
        )

        if (index !== this.glide.index) {
          this.glide.go(`=${index}`)
        }
      })
    })

    this.setControls(0)
  }

  setControls (index) {
    this.$refs.controls?.forEach((control) => {
      if (parseInt(control.getAttribute('data-index')) === index) {
        control.classList.add('c-feature-slider__control-button--active')
      } else {
        control.classList.remove('c-feature-slider__control-button--active')
      }
    })
  }
}

// Wait for images to load in
window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-c-feature-slider]')
    .forEach(el => new CFeatureSlider(el))
})
